export default "__VITE_ASSET__Be7zy7if__"